import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './page-header.html',
  styleUrl: './page-header.scss',
})
export class PageHeader {
  breadcrumbs = input<{ label: string; url: string }[]>([]);
  pageTitle = input<string>('');
  pageTitleUrl = input<string>('');
  showActions = input<boolean>(false);
  showTitle = input<boolean>(false);
}
